import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProgressBar from '../components/ProgressBar';
import combinationSkin from '../images/combination-skin.png';
import drySkin from '../images/dry-skin.png';
import idkSkin from '../images/idk.png';
import normalSkin from '../images/normal-skin.png';
import oilySkin from '../images/oily-skin.png';
import Popup from './Popup';
import './SkinType.css';

const SkinType = () => {
    // State variables for skin types, selected skin type, current step in the wizard, and popup visibility

    const [skinTypes, setSkinTypes] = useState([]);
    const [selectedSkinType, setSelectedSkinType] = useState({});
    // eslint-disable-next-line no-unused-vars
    const [currentStep, setCurrentStep] = useState(1);
    const [showSkipPopup, setShowSkipPopup] = useState(false);
    // React Router hooks for navigation and location
    const navigate = useNavigate();
    const location = useLocation();
    // Check if user navigated from the profile page
    const isFromProfile = location.state?.fromProfile || false;

    useEffect(() => {
         // Function to fetch skin types from the API
        const fetchSkinTypes = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch('https://dev-api.curu.com.au/api/skin-type', {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setSkinTypes(data);
                } else {
                    console.error('Failed to fetch skin types');
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };

        fetchSkinTypes();
// Retrieve stored skin type from session storage
        const storedSkinType = sessionStorage.getItem('skin-type') || {};
        let parsedSkinType;
        try {
            parsedSkinType = JSON.parse(storedSkinType);
        } catch (error) {
            parsedSkinType = {};
        }
        setSelectedSkinType(parsedSkinType);
    }, []);

    // Function to handle clicking "I don't know" option
    const handleIDKClick = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('https://dev-api.curu.com.au/api/questions?type=2', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('type2Questions', JSON.stringify(data));
                navigate('/type2-questions', { state: { isFromProfile } });

            } else {
                console.error('Failed to fetch questions');
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };
// Function to handle skin type selection
    const handleSelection = (typeId, typeName) => {
        if (typeName !== "I don't know") {
            sessionStorage.setItem('skin-type', JSON.stringify({ id: typeId, name: typeName }));
        }
        setSelectedSkinType({ id: typeId, name: typeName });
        if (typeName === "I don't know") {
            handleIDKClick();
        }
    };
// Function to handle skip button click
    const handleSkipClick = () => {
        setShowSkipPopup(true);
    };

    // Function to handle confirming skip action
    const handleSkipConfirm = () => {
        navigate('/skin-concerns');
        setShowSkipPopup(false);
    };
// Function to handle back button click
    const handleBackClick = () => {
        setCurrentStep(currentStep > 1 ? currentStep - 1 : 1);
        navigate('/home-page');
    };
// Function to handle next button click
    const handleNextClick = () => {
        navigate('/skin-concerns');
    };
// Function to update the user's profile with the selected skin type
    const handleUpdateClick = async () => {
        const storedSkinType = sessionStorage.getItem('skin-type');

        const parseAndExtractId = (storedValue) => {
            try {
                const parsedValue = JSON.parse(storedValue);
                return parsedValue?.id || null;
            } catch {
                return null;
            }
        };

        const skinTypeId = parseAndExtractId(storedSkinType);

        const quizData = {
            skin_type: skinTypeId,
        };

        console.log('Skin quiz data to store in database:', quizData);

        try {
            const response = await fetch('https://dev-api.curu.com.au/api/profile', {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(quizData)
            });

            if (!response.ok) {
                throw new Error('Failed to save the skin quiz data.');
            }

            navigate('/user-profile');
        } catch (error) {
            console.error('Error saving quiz data:', error.message);
            alert('There was a problem saving your quiz data. Please try again.');
        }
    };
// Map skin type names to their respective images
    const skinTypeImages = {
        'Dry': drySkin,
        'Oily': oilySkin,
        'Combination': combinationSkin,
        'Normal': normalSkin,
        "I don't know": idkSkin,
    };


// return (
//     <div className="page-container-skin-type">
//       <div className="skin-type-container">
//         {!isFromProfile && (
//           <button className="skip-link-skin-type" onClick={handleSkipClick}>Skip</button>
//         )}
//         <ProgressBar currentStep={currentStep} comboType="combo2" />
//         <h1 className="title-skin-type">Your Skin Type</h1>
//         <div className="options-skin-type">
//           {skinTypes.map((type, index) => (
//             <div key={type.id} className={`option-skin-type ${selectedSkinType.name === type.name ? 'selected' : ''}`}
//                  onClick={() => handleSelection(type.id, type.name)
                    
//                  }>
//               <img src={skinTypeImages[type.name]} alt={type.name} className="icon" />
//               <div className="radio-wrapper">
//                 <label htmlFor={`skin-type-option-${index}`} className="radio-label">
//                   <input
//                     type="radio"
//                     name="skinType"
//                     checked={selectedSkinType.name === type.name}
//                     onChange={() => handleSelection(type.id, type.name)}
//                     id={`skin-type-option-${index}`}
//                     className="radio-input"
//                   />
//                   <span className="skin-type-name">{type.name}</span>
//                 </label>
//               </div>
//               <div className="skin-type-description">{type.description}</div>
//             </div>
//           ))}
//         </div>
//         <div className="buttons-container-skin-type">
//           {!isFromProfile && (
//             <button className="back-button-skin-type" onClick={handleBackClick}>Back</button>
//           )}
//           {!isFromProfile ? (
//             <button
//               className="next-button-skin-type"
//               onClick={handleNextClick}
//               disabled={!selectedSkinType.name}
//             >
//               Next
//             </button>
//           ) : (
//             <>
//             <button
//   className="close-button-skin-sensitivity"
//   onClick={() => navigate('/user-profile')}
// >
//               Close
//             </button>
//             <button
//               className="update-button-skin-type"
//               onClick={handleUpdateClick}
//               disabled={!selectedSkinType.name}
//             >
//               Update
//             </button>
            
//           </>
      
//           )}
//         </div>
//         <Popup
//           isVisible={showSkipPopup}
//           title="Skip Skin Type"
//           onClose={() => setShowSkipPopup(false)}
//           onConfirm={handleSkipConfirm}
//         />
//         {/* Inline CSS for option hover and selected states */}
//         <style>{`
//           .option-skin-type:hover:not(.selected) {
//             background-color: rgba(255, 216, 219, 0.893);
//             transition: background-color 0.3s ease;
//           }
//           .option-skin-type.selected {
//             background-color: rgba(255, 216, 219, 0.893);
//             transition: background-color 0.3s ease;
//           }
//         `}</style>
//       </div>
//     </div>
//   );


















  // return (
  //   <div className="page-container-skin-type">
  //     <div className="skin-type-container">
  //       {!isFromProfile && (
  //         <button className="skip-link-skin-type" onClick={handleSkipClick}>Skip</button>
  //       )}
  //       <ProgressBar currentStep={currentStep} comboType="combo2" />
  //       <h1 className="title-skin-type">Your Skin Type</h1>
  //       <div className="options-skin-type">
  //         {skinTypes.map((type, index) => (
  //           <div
  //             key={type.id}
  //             className={`option-skin-type ${selectedSkinType.name === type.name ? 'selected' : ''}`}
  //             onClick={() => handleSelection(type.id, type.name)}
  //           >
  //             <div className="flip-card-inner">
  //               <div className="flip-card-face flip-card-front">
  //                 <img src={skinTypeImages[type.name]} alt={type.name} className="icon" />
  //                 <div className="radio-wrapper">
  //                   <label htmlFor={`skin-type-option-${index}`} className="radio-label">
  //                     <input
  //                       type="radio"
  //                       name="skinType"
  //                       checked={selectedSkinType.name === type.name}
  //                       onChange={() => handleSelection(type.id, type.name)}
  //                       id={`skin-type-option-${index}`}
  //                       className="radio-input"
  //                     />
  //                     <span className="skin-type-name">{type.name}</span>
  //                   </label>
  //                 </div>
  //               </div>

  //               <div className="flip-card-face flip-card-back">
  //                 <p className="skin-type-name" style={{ marginBottom: 6 }}>{type.name}</p>
  //                 <div className="skin-type-description">{type.description}</div>
  //               </div>
  //             </div>
  //           </div>
  //         ))}
  //       </div>

  //       <div className="buttons-container-skin-type">
  //         {!isFromProfile && (
  //           <button className="back-button-skin-type" onClick={handleBackClick}>Back</button>
  //         )}
  //         {!isFromProfile ? (
  //           <button
  //             className="next-button-skin-type"
  //             onClick={handleNextClick}
  //             disabled={!selectedSkinType.name}
  //           >
  //             Next
  //           </button>
  //         ) : (
  //           <>
  //             <button
  //               className="close-button-skin-sensitivity"
  //               onClick={() => navigate('/user-profile')}
  //             >
  //               Close
  //             </button>
  //             <button
  //               className="update-button-skin-type"
  //               onClick={handleUpdateClick}
  //               disabled={!selectedSkinType.name}
  //             >
  //               Update
  //             </button>
  //           </>
  //         )}
  //       </div>

  //       <Popup
  //         isVisible={showSkipPopup}
  //         title="Skip Skin Type"
  //         onClose={() => setShowSkipPopup(false)}
  //         onConfirm={handleSkipConfirm}
  //       />

  //       {/* Inline CSS for hover/selected + flip */}
  //       <style>{`
  //         .option-skin-type {
  //           perspective: 1000px;
  //           position: relative;
  //         }
  //         .flip-card-inner {
  //           position: relative;
  //           width: 100%;
  //           height: 100%;
  //           transform-style: preserve-3d;
  //           transition: transform 0.6s ease;
  //         }
  //         .option-skin-type:hover .flip-card-inner {
  //           transform: rotateY(180deg);
  //         }
  //         .flip-card-face {
  //           position: absolute;
  //           inset: 0;
  //           backface-visibility: hidden;
  //           display: flex;
  //           flex-direction: column;
  //           justify-content: center;
  //           align-items: flex-start;
  //           padding: 12px;
  //           border-radius: 10px;
  //         }
  //         .flip-card-front {}
  //         .flip-card-back {
  //           transform: rotateY(180deg);
  //         }
  //         .option-skin-type:hover:not(.selected) {
  //           background-color: rgba(255, 216, 219, 0.893);
  //           transition: background-color 0.3s ease;
  //         }
  //         .option-skin-type.selected {
  //           background-color: rgba(255, 216, 219, 0.893);
  //           transition: background-color 0.3s ease;
  //         }
  //       `}</style>
  //     </div>
  //   </div>
  // );



return (
  <div className="page-container-skin-type">
    <div className="skin-type-container">
      {!isFromProfile && (
        <button className="skip-link-skin-type" onClick={handleSkipClick}>Skip</button>
      )}

      <ProgressBar currentStep={currentStep} comboType="combo2" />
      <br></br>
      <br></br>
      <h1 className="title-skin-type">Your Skin Type</h1>
      <br></br>
      <div className="options-skin-type">
        {skinTypes.map((type, index) => (
          <div
            key={type.id}
            className={`option-skin-type ${selectedSkinType.name === type.name ? 'selected' : ''}`}
            onClick={() => handleSelection(type.id, type.name)}
            onMouseEnter={(e) => {
              const el = e.currentTarget;
              if (!el.classList.contains('spin-once')) {
                el.classList.add('spin-once');
              }
            }}
            onAnimationEnd={(e) => {
     
              e.currentTarget.classList.remove('spin-once');
            }}
          >
            <img src={skinTypeImages[type.name]} alt={type.name} className="icon" />
            <div className="radio-wrapper">
              <label htmlFor={`skin-type-option-${index}`} className="radio-label">
                <input
                  type="radio"
                  name="skinType"
                  checked={selectedSkinType.name === type.name}
                  onChange={() => handleSelection(type.id, type.name)}
                  id={`skin-type-option-${index}`}
                  className="radio-input"
                />
                <span className="skin-type-name">{type.name}</span>
              </label>
            </div>
            <div className="skin-type-description">{type.description}</div>
          </div>
        ))}
      </div>
      <br></br>
      <br></br>
      <div className="buttons-container-skin-type">
        {!isFromProfile && (
          <button className="back-button-skin-type" onClick={handleBackClick}>Back</button>
        )}
        {!isFromProfile ? (
          <button
            className="next-button-skin-type"
            onClick={handleNextClick}
            disabled={!selectedSkinType.name}
          >
            Next
          </button>
        ) : (
          <>
            <button
              className="close-button-skin-sensitivity"
              onClick={() => navigate('/user-profile')}
            >
              Close
            </button>
            <button
              className="update-button-skin-type"
              onClick={handleUpdateClick}
              disabled={!selectedSkinType.name}
            >
              Update
            </button>
          </>
        )}
      </div>

      <Popup
        isVisible={showSkipPopup}
        title="Skip Skin Type"
        onClose={() => setShowSkipPopup(false)}
        onConfirm={handleSkipConfirm}
      />

    </div>
  </div>
);

  
};


export default SkinType;


